export { DLHomeComponent } from './dl-home.component';
export { DLModule } from './documents-ledger.module'

export function isDLFeatureEnabled() {
  return process.env.FEATURE_DL_ENABLED === 'yes';
}
